import Joi from "joi";

const numberPattern = new RegExp("^[0-9]*$");

const TrialSchema = {
  mobileNumber: Joi.string()
    .allow("")
    .min(8)
    .max(15)
    .pattern(numberPattern)
    .messages({
      "string.pattern.base": "MobileValidation",
      "string.max": "MobileValidation",
      "string.min": "MobileValidation",
    }),
  emailId: Joi.string()
    .allow("")
    .email({ tlds: { allow: false } })
    .messages({
      "string.email": "EmailValidation",
      "string.pattern.base": "EmailLettersValidation",
    }),
};

export default TrialSchema;
